import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Vision from "./components/Vision";
import Packages from "./components/Packages"; // This is your services
import Membership from "./components/Membership";
import Reviews from "./components/Reviews";
import Booking from "./components/Booking";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingButton from "./components/FloatingButton";
import AddOns from "./components/AddOns";

function App() {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        "home",
        "vision",
        "services", // This should match the ID in Packages section
        "addons",
        "membership",
        "reviews",
        "booking",
        "contact",
      ];

      const scrollY = window.scrollY + 120;

      for (let id of sections) {
        const el = document.getElementById(id);
        if (!el) continue;

        if (
          scrollY >= el.offsetTop &&
          scrollY < el.offsetTop + el.offsetHeight
        ) {
          setActiveSection(id);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    console.log(`Scrolling to section: ${id}`); // Debug log
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      console.error(`Section with id "${id}" not found!`);
    }
  };

  return (
    <>
      <Navbar
        activeSection={activeSection}
        scrollToSection={scrollToSection}
      />

      <section id="home">
        <Hero scrollToSection={scrollToSection} />
      </section>

      <section id="vision">
        <Vision />
      </section>

      <section id="services"> {/* This is the ID that Hero.js is looking for */}
        <Packages />
      </section>

      <section id="addons">
        <AddOns />
      </section>

      <section id="membership">
        <Membership />
      </section>

      <section id="reviews">
        <Reviews />
      </section>

      <section id="booking">
        <Booking />
      </section>

      <section id="contact">
        <Contact />
      </section>

      <Footer />
      <FloatingButton scrollToSection={scrollToSection} />
    </>
  );
}

export default App;